export const TYRES_LIST_REQUEST = 'TYRES_LIST_REQUEST'
export const TYRES_LIST_SUCCESS = 'TYPES_LIST_SUCCESS'
export const TYRES_LIST_FAIL = 'TYPES_LIST_FAIL'

export const SELECT_TYRE = 'SELECT_TYRE'
